/**
 * Application configuration constants
 * Loads values from environment variables (.env files)
 */

export const API_CONFIG = {
  // ASP.NET Core API base URL
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:5220',

  // Azure AD configuration
  azureClientId: import.meta.env.VITE_AZURE_CLIENT_ID,
  azureTenantId: import.meta.env.VITE_AZURE_TENANT_ID,

  // ConnectWise configuration
  connectwiseOrigin: import.meta.env.VITE_CONNECTWISE_ORIGIN,

  // API endpoints
  endpoints: {
    health: '/health',
    token: '/api/bots/token',
    invokeBot: '/api/bots/invoke-akka',  // Using Akka Agent instead of Copilot Studio
    invokeCopilot: '/api/bots/invoke-agents-sdk',  // Legacy Copilot Studio endpoint
    conversations: '/api/bots/conversations'
  }
};

/**
 * Azure AD MSAL configuration
 * Configured for iframe/popup authentication (ConnectWise Pod compatibility)
 */
export const getMsalConfig = () => ({
  auth: {
    clientId: API_CONFIG.azureClientId,
    authority: `https://login.microsoftonline.com/${API_CONFIG.azureTenantId}`,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false // Don't navigate after login (better for popups)
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true // Enable for better iframe/popup support
  },
  system: {
    allowNativeBroker: false, // Disable native broker for web-only scenarios
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0
  }
});

/**
 * Azure AD token request scopes
 */
export const getTokenRequest = () => ({
  scopes: [`api://${API_CONFIG.azureClientId}/access_as_user`]
});
